/**
 * Employee Web — `/me/overtime` route.
 *
 * Mounts <MyOvertimePage> from `@linkhr/employee-self-service`. Replaces the
 * polymorphic `/me/requests?type=overtime` filter with a dedicated screen
 * per reference design `pages/overtime.jsx`.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { MyOvertimePage } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/overtime")({
  staticData: { breadcrumb: { labelKey: "me-overtime:page.title" } },
  component: MyOvertimeRoute,
});

function MyOvertimeRoute(): JSX.Element {
  return <MyOvertimePage />;
}
